import type * as React from 'react';
import { get } from '@Domain/Api';
import aiProvidersFetched, {
	type AiProvidersFetchedAction,
	type AiProvidersFetchedPayload,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProvidersFetched';
import aiProvidersFetchFailed, {
	type AiProvidersFetchFailedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProvidersFetchFailed';
import type FetchAiProviders from '@Application/Ai/AiConfiguration/Providers/Queries/FetchAiProviders';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiProvidersFetchedAction | AiProvidersFetchFailedAction;

export default (query: FetchAiProviders) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiProvidersFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/ai-providers`,
			);

			const action = aiProvidersFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiProvidersFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
